module.exports = __webpack_public_path__ + "media/audio3.43ab383e.mp3";